import React from "react";

import Link from "../../../../components/Link";
import Typography from "../../../../components/Text";

// Config
import Config from "../../Config";
// CSS
import css from "./Navigation.module.scss";

// Constants
const { ROUTES } = Config;

/**
 * Renders a navigation bar for the engagement section
 */
const Navigation = () => (
	<div className={css.topNav}>
		{Object.keys(ROUTES).map((route) => {
			const { label, url } = ROUTES[route];
			return (
				<div key={route} className={`${css.navOption} ${window.location.pathname === url ? css.active : ""}`}>
					<Typography className={css.linkText} size="paragraph-3" color="neutral-3" weight="semi-bold">
						<Link noUnderline href={url}>
							{label}
						</Link>
					</Typography>
				</div>
			);
		})}
	</div>
);

export default Navigation;
